export default "__VITE_ASSET__B_ACtew0__"